import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ProductForm from './ProductForm';

export class ProductCreateForm extends CreateView {
    protected getFormComponent() {
        return ProductForm;
    }
}

export default ProductCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(ProductCreateForm));
